// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"home_text_image_block-module--imageContainer--3zAcH","image":"home_text_image_block-module--image--3DHzF"};